/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsersRouteImport } from './routes/users'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LlmRouteImport } from './routes/llm'
import { Route as AccountRouteImport } from './routes/account'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SitesSiteIdRouteImport } from './routes/sites.$siteId'
import { Route as ReportSiteIdRouteImport } from './routes/report.$siteId'
import { Route as RTokenRouteImport } from './routes/r.$token'
import { Route as SitesSiteIdAlertsRouteImport } from './routes/sites.$siteId.alerts'
import { Route as SitesSiteIdCamerasCameraIdRouteImport } from './routes/sites.$siteId.cameras.$cameraId'

const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LlmRoute = LlmRouteImport.update({
  id: '/llm',
  path: '/llm',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SitesSiteIdRoute = SitesSiteIdRouteImport.update({
  id: '/sites/$siteId',
  path: '/sites/$siteId',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportSiteIdRoute = ReportSiteIdRouteImport.update({
  id: '/report/$siteId',
  path: '/report/$siteId',
  getParentRoute: () => rootRouteImport,
} as any)
const RTokenRoute = RTokenRouteImport.update({
  id: '/r/$token',
  path: '/r/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SitesSiteIdAlertsRoute = SitesSiteIdAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => SitesSiteIdRoute,
} as any)
const SitesSiteIdCamerasCameraIdRoute =
  SitesSiteIdCamerasCameraIdRouteImport.update({
    id: '/cameras/$cameraId',
    path: '/cameras/$cameraId',
    getParentRoute: () => SitesSiteIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/llm': typeof LlmRoute
  '/login': typeof LoginRoute
  '/users': typeof UsersRoute
  '/r/$token': typeof RTokenRoute
  '/report/$siteId': typeof ReportSiteIdRoute
  '/sites/$siteId': typeof SitesSiteIdRouteWithChildren
  '/sites/$siteId/alerts': typeof SitesSiteIdAlertsRoute
  '/sites/$siteId/cameras/$cameraId': typeof SitesSiteIdCamerasCameraIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/llm': typeof LlmRoute
  '/login': typeof LoginRoute
  '/users': typeof UsersRoute
  '/r/$token': typeof RTokenRoute
  '/report/$siteId': typeof ReportSiteIdRoute
  '/sites/$siteId': typeof SitesSiteIdRouteWithChildren
  '/sites/$siteId/alerts': typeof SitesSiteIdAlertsRoute
  '/sites/$siteId/cameras/$cameraId': typeof SitesSiteIdCamerasCameraIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/llm': typeof LlmRoute
  '/login': typeof LoginRoute
  '/users': typeof UsersRoute
  '/r/$token': typeof RTokenRoute
  '/report/$siteId': typeof ReportSiteIdRoute
  '/sites/$siteId': typeof SitesSiteIdRouteWithChildren
  '/sites/$siteId/alerts': typeof SitesSiteIdAlertsRoute
  '/sites/$siteId/cameras/$cameraId': typeof SitesSiteIdCamerasCameraIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/llm'
    | '/login'
    | '/users'
    | '/r/$token'
    | '/report/$siteId'
    | '/sites/$siteId'
    | '/sites/$siteId/alerts'
    | '/sites/$siteId/cameras/$cameraId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/llm'
    | '/login'
    | '/users'
    | '/r/$token'
    | '/report/$siteId'
    | '/sites/$siteId'
    | '/sites/$siteId/alerts'
    | '/sites/$siteId/cameras/$cameraId'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/llm'
    | '/login'
    | '/users'
    | '/r/$token'
    | '/report/$siteId'
    | '/sites/$siteId'
    | '/sites/$siteId/alerts'
    | '/sites/$siteId/cameras/$cameraId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRoute
  LlmRoute: typeof LlmRoute
  LoginRoute: typeof LoginRoute
  UsersRoute: typeof UsersRoute
  RTokenRoute: typeof RTokenRoute
  ReportSiteIdRoute: typeof ReportSiteIdRoute
  SitesSiteIdRoute: typeof SitesSiteIdRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/llm': {
      id: '/llm'
      path: '/llm'
      fullPath: '/llm'
      preLoaderRoute: typeof LlmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sites/$siteId': {
      id: '/sites/$siteId'
      path: '/sites/$siteId'
      fullPath: '/sites/$siteId'
      preLoaderRoute: typeof SitesSiteIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/report/$siteId': {
      id: '/report/$siteId'
      path: '/report/$siteId'
      fullPath: '/report/$siteId'
      preLoaderRoute: typeof ReportSiteIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/r/$token': {
      id: '/r/$token'
      path: '/r/$token'
      fullPath: '/r/$token'
      preLoaderRoute: typeof RTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sites/$siteId/alerts': {
      id: '/sites/$siteId/alerts'
      path: '/alerts'
      fullPath: '/sites/$siteId/alerts'
      preLoaderRoute: typeof SitesSiteIdAlertsRouteImport
      parentRoute: typeof SitesSiteIdRoute
    }
    '/sites/$siteId/cameras/$cameraId': {
      id: '/sites/$siteId/cameras/$cameraId'
      path: '/cameras/$cameraId'
      fullPath: '/sites/$siteId/cameras/$cameraId'
      preLoaderRoute: typeof SitesSiteIdCamerasCameraIdRouteImport
      parentRoute: typeof SitesSiteIdRoute
    }
  }
}

interface SitesSiteIdRouteChildren {
  SitesSiteIdAlertsRoute: typeof SitesSiteIdAlertsRoute
  SitesSiteIdCamerasCameraIdRoute: typeof SitesSiteIdCamerasCameraIdRoute
}

const SitesSiteIdRouteChildren: SitesSiteIdRouteChildren = {
  SitesSiteIdAlertsRoute: SitesSiteIdAlertsRoute,
  SitesSiteIdCamerasCameraIdRoute: SitesSiteIdCamerasCameraIdRoute,
}

const SitesSiteIdRouteWithChildren = SitesSiteIdRoute._addFileChildren(
  SitesSiteIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRoute,
  LlmRoute: LlmRoute,
  LoginRoute: LoginRoute,
  UsersRoute: UsersRoute,
  RTokenRoute: RTokenRoute,
  ReportSiteIdRoute: ReportSiteIdRoute,
  SitesSiteIdRoute: SitesSiteIdRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
